import { Bar } from "react-chartjs-2";


export const Ergonomics5Risks = ({ bins, mode="positive" }) => {

  const data = {
    labels: ['Négligeable', 'Correct', 'Moyen', 'Important', 'Critique'],
    datasets: [
      {
        data: bins,
        backgroundColor: [
          "rgba(102, 205, 170, 1)",
          "rgba(144, 238, 144, 1)",
          "rgba(255, 205, 86, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(255, 99, 132, 1)",
        ],
        categoryPercentage: 0.9,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        ticks: { display: false },
        grid: { display: false }
      },
      y: {
        min: mode === 'positive' ? 0 : -100,
        max: 100,
        beginAtZero: true,
        ticks: {
          display: false,
          autoSkip: false,
          stepSize: 20,
        },
        title: {
          display: false,
          // text: 'Répartition (%)',
        },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.parsed.y}%`;
          },
        },
      },
    },
  };

  return (
    <Bar data={data} options={options} />
  );
};